/*
 * Sold-out products last, hidden until the last page.
 *
 * Shopify has no "out of stock last" sort order, so a sold-out card can land in
 * the middle of a collection page. The grid items are inline-block, not flex or
 * grid children, so CSS `order` is not available — the nodes get moved instead.
 * Sold-out cards also stay hidden (display: none) on every page except the
 * last one, so browsing a collection normally never shows them; they only
 * appear once the shopper has reached the end of the results (last numbered
 * page, or the end of infinite scroll / show-more).
 *
 * Cards are marked server-side (data-sold-out in
 * snippets/collection-product-grid.liquid — a distinct name, because the theme
 * already puts data-available on the add-to-cart buttons inside each card).
 * Infinite scrolling appends each new
 * page into the same <ul> (halo.ajaxInfiniteScrollingMapData in theme.js) and
 * the facet filters swap the grid out wholesale, so the pass re-runs whenever
 * the grid changes — including when a fresh pagination block arrives, so the
 * last-page check is always read from the current DOM.
 */
(function () {
  var moving = false;

  function isLastPage(scope) {
    if (scope.querySelector('[data-infinite-scrolling]')) return false;
    if (scope.querySelector('.pagination__item--next')) return false;
    return true;
  }

  function updateList(list, lastPage) {
    var kids = list.children;
    var soldOut = [];

    for (var i = 0; i < kids.length; i++) {
      if (kids[i].hasAttribute('data-sold-out')) soldOut.push(kids[i]);
    }
    if (!soldOut.length) return;

    for (var v = 0; v < soldOut.length; v++) {
      soldOut[v].style.display = lastPage ? '' : 'none';
    }
    if (!lastPage) return;

    // Leave the DOM alone when they already occupy the final slots.
    var offset = kids.length - soldOut.length;
    var settled = true;
    for (var j = 0; j < soldOut.length; j++) {
      if (soldOut[j] !== kids[offset + j]) { settled = false; break; }
    }
    if (settled) return;

    moving = true;
    for (var k = 0; k < soldOut.length; k++) list.appendChild(soldOut[k]);
    moving = false;
  }

  function init() {
    var scope = document.getElementById('CollectionProductGrid');
    if (!scope) return;

    var run = function () {
      var lastPage = isLastPage(scope);
      var lists = scope.querySelectorAll('.productListing');
      for (var i = 0; i < lists.length; i++) updateList(lists[i], lastPage);
    };

    run();

    var queued = false;
    new MutationObserver(function () {
      if (moving || queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (!moving) run();
      });
    }).observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
